/*
 * @Descripttion: 属性组件注册
 * @Author: zenghua.wang
 * @Date: 2021-04-14 11:15:18
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-10 10:55:45
 */
import Vue from 'vue'

// 布局组件
import grid from './layout/grid.vue'
import column from './layout/column.vue'
import condition from './layout/condition/index.vue'
import tabs from './layout/tabs/index.vue'

// 基础组件
import report from './report/index.vue'
import scrollboad from './scrollboad/index.vue'
import card from './card/card.vue'
import dynamicCard from './card/dynamicCard.vue'
import border from './border/index.vue'
import swiper from './swiper/index.vue'
import image from './image/index.vue'
import progress from './progress/index.vue'
import text from './text/index.vue'
import datetime from './datetime/index.vue'
import iframe from './iframe/index.vue'
import button from './button/index.vue'

// 图表组件
import bar from './echart/bar.vue'
import line from './echart/line.vue'
import pie from './echart/pie.vue'
import funnel from './echart/funnel.vue'
import gauge from './echart/gauge.vue'
import radar from './echart/radar.vue'

const configComponents = [
  tabs,
  grid,
  column,
  condition,
  card,
  dynamicCard,
  report,
  scrollboad,
  border,
  swiper,
  image,
  progress,
  text,
  datetime,
  iframe,
  button,
  bar,
  line,
  pie,
  funnel,
  gauge,
  radar
]

export const Config = {
  install(Vue) {
    if (this.installed) return
    this.installed = true
    configComponents.map(component => {
      Vue.component(component.name, component)
    })
  }
}

Vue.use(Config)
